import { render, staticRenderFns } from "./NoAuthorization.vue?vue&type=template&id=c053fcf8&scoped=true&lang=html&"
import script from "./NoAuthorization.vue?vue&type=script&lang=js&"
export * from "./NoAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./NoAuthorization.vue?vue&type=style&index=0&id=c053fcf8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c053fcf8",
  null
  
)

export default component.exports